<template>
  <div class="addon-row flex flex-wrap md:flex-nowrap">
    <div
      v-for="(cell, index) in row"
      :key="index"
      class="addon cell-size cell-colors cell-borders justify-center md:justify-start"
    >
      <!-- STRING -->
      <template v-if="isTemplate(cell, 'string')">
        {{ $t(cell) }}
      </template>

      <!-- OBJECT -->
      <template v-else-if="isTemplate(cell, 'object')">
        {{ $t(cell.value, cell.params) }}
      </template>

      <!-- BOOLEAN -->
      <template v-else-if="isTemplate(cell, 'boolean')">
        <img
          :src="iconSrc(cell)"
          :alt="iconAlt(cell)"
          :class="iconClass(cell)"
          class="boolean-icon"
        />
      </template>
    </div>
  </div>
</template>

<script>
import checkIcon from '@/assets/images/check.svg'
import minusIcon from '@/assets/images/minus.svg'

export default {
  props: ['row'],
  computed: {
    iconSrc() {
      const map = { true: checkIcon, false: minusIcon }
      return (value) => map[value]
    },
    iconAlt() {
      const map = { true: 'Check Icon', false: 'Minus Icon' }
      return (value) => map[value]
    },
    iconClass() {
      const map = { true: 'check-icon', false: 'minus-icon' }
      return (value) => map[value]
    },
  },
  methods: {
    isTemplate(cell, type) {
      return typeof cell === type
    },
  },
}
</script>

<style src="../tailwind.css" scoped></style>
<style lang="scss" src="../styles/AddonRow.scss"></style>
